import http from "./index";

const getAll = () => {
  return http.get("/days");
};

const getOne = (id) => {
  return http.get(`/days/${id}`);
};

const create = (data) => {
  return http.post("/days", data);
};

const update = (id, data) => {
  return http.put(`/days/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/days/${id}`);
};

const saveEmitions = (id, data) => {
  return http.put(`./days/${id}/save-emisiones`, { emitions: data });
};

const SaveEmitionsBulk = (data) => {
  return http.post(`./days/save-emitions-bulk`, data);
};

const dayService = {
  getAll,
  getOne,
  create,
  update,
  remove,
  saveEmitions,
  SaveEmitionsBulk,
};

export default dayService;
